var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCanceledByVisitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55469 10C1.55469 11.7306 2.06787 13.4223 3.02933 14.8612C3.99079 16.3002 5.35735 17.4217 6.95621 18.0839C8.55506 18.7462 10.3144 18.9195 12.0117 18.5819C13.7091 18.2442 15.2682 17.4109 16.4919 16.1872C17.7156 14.9635 18.5489 13.4044 18.8866 11.707C19.2242 10.0097 19.0509 8.25037 18.3886 6.65152C17.7264 5.05267 16.6049 3.6861 15.1659 2.72464C13.727 1.76318 12.0353 1.25 10.3047 1.25C7.98404 1.25 5.75845 2.17187 4.1175 3.81282C2.47656 5.45376 1.55469 7.67936 1.55469 10ZM16.0234 14.8438L5.46094 4.28125C6.89884 3.08437 8.73214 2.46811 10.601 2.55341C12.4699 2.63872 14.2395 3.41942 15.5624 4.74231C16.8853 6.0652 17.666 7.83474 17.7513 9.70364C17.8366 11.5725 17.2203 13.4059 16.0234 14.8438ZM5.45469 15.725C3.94114 14.4397 2.99906 12.6066 2.83504 10.6278C2.67101 8.64888 3.29842 6.68572 4.57969 5.16875L15.1359 15.725C13.7823 16.8688 12.0674 17.4963 10.2953 17.4963C8.52318 17.4963 6.8083 16.8688 5.45469 15.725Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCanceledByVisitor);
export default __webpack_public_path__ + "static/media/ic-canceled-by-visitor.011d72d4859199f36422187df38f74e7.svg";
export { ForwardRef as ReactComponent };